export default __webpack_public_path__ + "static/galeria-bg-main-a9ee73d01ebf7f422162491c43c86263.jpg";